import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'

export const TypeReferentielFormation = ['Rncp', 'Formacode'] as const

export type TypeReferentielFormation = typeof TypeReferentielFormation[number]

export const TypeReferentielFormationLibelle: UnionTypeLibelle<TypeReferentielFormation> = {
  Rncp: 'RNCP',
  Formacode: 'Formacode'
} as const
